// material-ui
import { useTheme, styled } from '@mui/material/styles';
import { Box, Container, Grid, IconButton, Link, Stack, Typography } from '@mui/material'; // Divider
import FacebookIcon from '@mui/icons-material/Facebook';
import YouTubeIcon from '@mui/icons-material/YouTube';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

// project import
import Logo from 'ui-component/Logo';

// Link - custom style
const FooterLink = styled(Link)(({ theme }) => ({
    color: theme.palette.mode === 'dark' ? theme.palette.text.secondary : theme.palette.text.hint,
    '&:hover': {
        color: theme.palette.primary.main
    },
    '&:active': {
        color: theme.palette.primary.main
    }
}));

// =============================|| LANDING - FOOTER SECTION ||============================= //

const FooterSection = () => {
    const theme = useTheme();
    const textColor = theme.palette.mode === 'dark' ? 'text.secondary' : 'text.hint';

    // const dividerSX = {
    //     borderImageSlice: 1,
    //     borderImageSource: `linear-gradient(90deg, rgba(255, 255, 255, 0) -0.01%, rgba(255, 255, 255, 0.56) 51.97%, rgba(255, 255, 255, 0.03) 99.99%)`,
    //     opacity: 0.5
    // };

    return (
        <>
            <Container sx={{ mb: 1, textAlign: 'center', justifyContent: 'center', paddingBottom: '20px', color: '#000' }}>
                <Grid container spacing={2}>
                    {/* <Grid item xs={12}>
                            <Stack spacing={4.25}>
                                <Divider sx={dividerSX} />
                                <Stack
                                    direction="row"
                                    justifyContent="center"
                                    spacing={{ xs: 1.5, sm: 6, md: 10, lg: 12 }}
                                    sx={{ overflow: 'hidden' }}
                                >
                                    <img src={Dribble} alt="dribble" />
                                    <img src={Freepik} alt="freepik" />
                                    <img src={Awards} alt="awards" />
                                </Stack>
                                <Divider sx={dividerSX} />
                            </Stack>
                        </Grid> */}
                    <Grid size={{ xs: 12, sm: 6, md: 3 }} sx={{ padding: 0 }}>
                        <Stack spacing={3} sx={{ width: '80%' }} textAlign="left">
                            <Logo widthValue="200px" />
                            <Grid container spacing={3} style={{ marginTop: '8px', color: '#000' }}>
                                <Grid size={12} style={{ padding: '0px' }}>
                                    <Stack direction="column" spacing={1} textAlign="left">
                                        <FooterLink sx={{ color: '#000' }} href="#" target="_blank" underline="none">
                                            📨 info@datahub.ai
                                        </FooterLink>

                                        <Stack direction="row" spacing={0} alignItems="center">
                                            <IconButton>
                                                <FacebookIcon
                                                    sx={{
                                                        color:
                                                            theme.palette.mode === 'dark'
                                                                ? theme.palette.text.secondary
                                                                : theme.palette.primary.main
                                                    }}
                                                />
                                            </IconButton>
                                            <IconButton>
                                                <YouTubeIcon
                                                    sx={{
                                                        color:
                                                            theme.palette.mode === 'dark'
                                                                ? theme.palette.text.secondary
                                                                : theme.palette.error.main
                                                    }}
                                                />
                                            </IconButton>
                                            <IconButton>
                                                <LinkedInIcon sx={{ color: '#87CEEB' }} />
                                            </IconButton>
                                        </Stack>
                                    </Stack>
                                </Grid>
                            </Grid>
                        </Stack>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 3 }} sx={{ padding: 0 }}>
                        <Stack spacing={{ xs: 2, md: 2 }} textAlign="left">
                            <Typography variant="h4" color="#000" sx={{ fontWeight: 500 }}>
                                CÔNG TY
                            </Typography>
                            <Stack spacing={{ xs: 2, md: 2 }}>
                                <FooterLink sx={{ color: '#000' }} href="/pages/homepage" target="_blank" underline="none">
                                    Trang chủ
                                </FooterLink>
                                <FooterLink sx={{ color: '#000' }} href="#" target="_blank" underline="none">
                                    Về chúng tôi
                                </FooterLink>
                                <FooterLink sx={{ color: '#000' }} href="#" target="_blank" underline="none">
                                    Tin tức
                                </FooterLink>
                                <FooterLink sx={{ color: '#000' }} href="/pages/privacy-policy" target="_blank" underline="none">
                                    Chính sách bảo mật
                                </FooterLink>
                                <FooterLink sx={{ color: '#000' }} href="/pages/term-of-use" target="_blank" underline="none">
                                    Điều khoản sử dụng
                                </FooterLink>
                            </Stack>
                        </Stack>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 3 }} sx={{ padding: 0 }}>
                        <Stack spacing={{ xs: 2, md: 2 }} textAlign="left">
                            <Typography variant="h4" color="#000" sx={{ fontWeight: 500 }}>
                                SẢN PHẨM
                            </Typography>
                            <Stack spacing={{ xs: 2, md: 2 }}>
                                <FooterLink sx={{ color: '#000' }} href="#" target="_blank" underline="none">
                                    Multi-Cloud Storage
                                </FooterLink>
                                <FooterLink sx={{ color: '#000' }} href="#" target="_blank" underline="none">
                                    JupyterHub
                                </FooterLink>
                                <FooterLink sx={{ color: '#000' }} href="#" target="_blank" underline="none">
                                    Apache Airflow
                                </FooterLink>
                                <FooterLink sx={{ color: '#000' }} href="#" target="_blank" underline="none">
                                    MongoDB
                                </FooterLink>
                                <FooterLink sx={{ color: '#000' }} href="#" target="_blank" underline="none">
                                    API Platform
                                </FooterLink>
                                <FooterLink sx={{ color: '#000' }} href="#" target="_blank" underline="none">
                                    API Gateway
                                </FooterLink>
                            </Stack>
                        </Stack>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 3 }} sx={{ padding: 0 }}>
                        <Stack spacing={{ xs: 2, md: 2 }} textAlign="left">
                            <Typography variant="h4" color="#000" sx={{ fontWeight: 500 }}>
                                HỖ TRỢ KHÁCH HÀNG
                            </Typography>
                            <Stack spacing={{ xs: 2, md: 2 }}>
                                <Stack direction="row">
                                    <span>Email: </span>{' '}
                                    <FooterLink sx={{ marginLeft: '5px', color: '#000' }} href="#" target="_blank">
                                        info@datahub.ai
                                    </FooterLink>
                                </Stack>

                                <FooterLink sx={{ color: '#000' }} href="/pages/faqs" target="_blank" underline="none">
                                    Câu hỏi thường gặp
                                </FooterLink>
                                {/* <FooterLink sx={{ color: '#000' }} href="#" target="_blank" underline="none">
                                    Hướng dẫn sử dụng
                                </FooterLink> */}
                                <FooterLink sx={{ color: '#000' }} href="/pages/contact-us" target="_blank" underline="none">
                                    Gửi yêu cầu hỗ trợ
                                </FooterLink>
                            </Stack>
                        </Stack>
                    </Grid>
                </Grid>
            </Container>
            <Box sx={{ bgcolor: 'dark.dark', py: { xs: 3, sm: 1.5 } }}>
                <Container>
                    <Stack
                        direction={{ xs: 'column', sm: 'row' }}
                        alignItems="center"
                        justifyContent="space-between"
                        spacing={{ xs: 1.5, sm: 1, md: 3 }}
                    >
                        <Typography color="text.secondary">
                            © 2024|Bản quyền thuộc về DataHub by N2N{' '}
                            {/* <Link href="https://codedthemes.com/" target="_blank" underline="hover">
                                    CodedThemes
                                </Link> */}
                        </Typography>
                    </Stack>
                </Container>
            </Box>
        </>
    );
};

export default FooterSection;
